var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noun_envelope_1560741",
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.81,
    height: 26.539,
    viewBox: "0 0 39.81 26.539",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_235",
    "data-name": "Group 235",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_348",
    "data-name": "Path 348",
    d: "M1275.8,292.068a2.649,2.649,0,0,0,.707,1.267l16.513,16.514a2.652,2.652,0,0,0,3.779,0l16.516-16.518a2.638,2.638,0,0,0,.706-1.266Zm-.8,1.492v22.332a2.709,2.709,0,0,0,2.715,2.715h34.38a2.709,2.709,0,0,0,2.715-2.715V293.564a4.034,4.034,0,0,1-.561.71l-16.516,16.517a4,4,0,0,1-5.655,0l-16.514-16.514A3.979,3.979,0,0,1,1275,293.56Z",
    transform: "translate(-1275 -292.068)",
    fill: "#f68e3f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.d70f30eda02aa32b7cb70f649f47ce22.svg";
export { ForwardRef as ReactComponent };